import { render, staticRenderFns } from "./Needs.vue?vue&type=template&id=f89e801a&"
import script from "./Needs.vue?vue&type=script&lang=ts&"
export * from "./Needs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports